<template>
    <v-tab-item eager>
        <v-card
            color="grey lighten-3"
            flat
        >
            <v-card-text>

                <v-card-subtitle style="color: var(--pagination-color)">
                    <div class="magnify">
                        <v-icon color="white">mdi-magnify</v-icon>
                    </div>
                    <div class="filter-description">
                        <p>{{Object.keys(currentItems).length}}/{{Object.keys(resources).length}} entries selected</p>
                        <v-chip-group>
                            <v-chip
                                v-for="item in currentItems"
                                :key="`${resourceName}_${item.id}`"
                                close
                                @click:close="deselect(item.id)"
                                color="var(--main-header)"
                                text-color="white"
                            >
                                <span v-html="item.name" />
                            </v-chip>
                        </v-chip-group>
                    </div>
                </v-card-subtitle>

                <v-text-field
                    ref="search"
                    v-model="search"
                    :label="$t('Filter Selection')"
                    autofocus
                    class="my-3 filter-checkboxes"
                    clearable
                    hide-details
                    prepend-inner-icon="mdi-search"
                    @keyup.enter="selectFilteredValue"
                />

                <div
                    class="grid mt-2"
                >
                    <label
                        v-for="item in filteredItems"
                        :key="item.id"
                        :for="`${resourceName}_${item.id}`"
                    >
                        <input
                            :id="`${resourceName}_${item.id}`"
                            v-model="internalValue"
                            type="checkbox"
                            :value="item.id"
                            class="mr-3"
                        >
                        <span v-html="item.name" />
                    </label>
                </div>
            </v-card-text>
        </v-card>
    </v-tab-item>
</template>
<script>
import {map} from 'lodash';

export default {
        name: 'DataFilterItem',
        props: {
            value: {
                type: [Array, Number],
                default: null
            },
            resourceName: String,
            resources: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                items: this.resources,
                internalValue: this.value,
                search: null,
                pending: false,
                showLoading: false,
            };
        },

        computed: {
            // current selected items
            currentItems() {
                return this.items.filter(item => {
                    if (Array.isArray(this.internalValue)) {
                        return this.internalValue.includes(item.id)
                    }

                    return item.id === this.internalValue;
                });
            },
            // filter items for search value
            filteredItems() {
                // search for values is empty, return all items
                if (!this.search) {
                    return this.items;
                }
                // return filtered list of items
                return this.items.filter(
                    item => {
                        return item.name.toUpperCase().normalize('NFC').includes(this.search.toUpperCase().normalize('NFC'))
                    });
            },
        },

        watch: {
            // update internal value based on external changes
            value(newValue) {
                this.internalValue = newValue
            },

            // emit event when internal filters are changed
            internalValue(newInternalValue) {
                this.$emit('input', newInternalValue)
            },
        },

        methods: {
            deselect(value) {
                if (Array.isArray(this.internalValue)) {
                    this.internalValue = this.internalValue.filter(v => v != value);
                } else {
                    this.internalValue = null;
                }
            },

            deselectAll() {
                this.internalValue = Array.isArray(this.value) ? [] : null;
            },

            selectAllFiltered() {
                if (!Array.isArray(this.value)) {
                    return;
                }

                this.internalValue = map(this.filteredItems, 'id');
            },

            toggleSelect() {
                if (!Array.isArray(this.value)) {
                    return;
                }

                let newValue = this.items.filter(item => !this.currentItems.includes(item));
                this.internalValue = map(newValue, 'id');
            },

            selectFilteredValue() {
                if (this.filteredItems.length === 1) {
                    let newValue = Array.isArray(this.value) ? this.filteredItems : this.filteredItems[0];
                    this.internalValue = map(newValue, 'id');
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../../node_modules/vuetify/src/components/VCard/variables";
    @import "../../../../node_modules/vuetify/src/components/VChip/variables";

    .row {
        flex-wrap: nowrap;
        overflow: auto;
    }

    .grid {
        display: grid;
        grid-template-rows: repeat(6, calc(#{$card-text-font-size} + 1.5rem));
        grid-auto-flow: column;
        justify-content: start;
        overflow-x: auto;
    }

    .grid label {
        white-space: nowrap;
        margin-right: 1rem;
        margin-bottom: 0.5rem;
    }

    .grid label input:focus + span {
        color: var(--main-header);
        text-shadow: 0 0 6px var(--table-no-data-color);
    }

    .v-item-group {
        min-height: 3rem;
    }

    div.magnify i {
        background-color: var(--main-header);
        border-radius: 100px;
        padding: 16px;
    }
    div.magnify {
        margin-top: 6px;
    }
    div.filter-description p {
        margin-bottom: 0;
    }
    div.v-card__subtitle {
        display: flex;
        gap: 16px;
        padding-bottom: 0;
    }
    div.v-input.filter-checkboxes {
        margin-top: 0 !important;
    }

    [type="checkbox"] + span {
        display: inline-block;
        padding-right: 8px;
    }
    [type="checkbox"] {
        position: relative;
        left: 15px;
        top: -4px;
        z-index: 0;
        -webkit-appearance: none;
    }
    [type="checkbox"] + span::before {
        width: 24px;
        height: 24px;
        background-image: url("../../../assets/icons/check_box_unchecked.svg");
        background-size: 24px;
        display: block;
        content: "";
        float: left;
        z-index: 5;
        position: relative;
        margin-right: 4px;
    }
    [type="checkbox"]:checked+span::before {
        background-image: url("../../../assets/icons/check_box_checked.svg");
    }
</style>
